import { AlertType, PartnerSettingsAlertDto } from '@generatedTypes/data-contracts';
import { HourPriceAlertRow } from '@components/AlertCenter/AlertRows/partnerSettings/HourPriceAlertRow';
import { MaterialMarginAlertRow } from '@components/AlertCenter/AlertRows/partnerSettings/MaterialMarginAlertRow';
import { PartnerLogotypeAlertRow } from '@components/AlertCenter/AlertRows/partnerSettings/PartnerLogotypeAlertRow';
import { OfferTermsAlertRow } from '@components/AlertCenter/AlertRows/partnerSettings/OfferTermsAlertRow';

export const PartnerSettingsAlertRow = ({ alert }: { alert: PartnerSettingsAlertDto }) => {
  if (alert.alertType === AlertType.MissingHourlyRate) {
    return <HourPriceAlertRow />;
  }

  if (alert.alertType === AlertType.MissingMargin) {
    return <MaterialMarginAlertRow />;
  }

  if (alert.alertType === AlertType.MissingPartnerLogotype) {
    return <PartnerLogotypeAlertRow />;
  }

  if (alert.alertType === AlertType.MissingOfferTerms) {
    return <OfferTermsAlertRow />;
  }

  //eslint-disable-next-line
  console.error(`PartnerSettingsAlertRow: alertType ${alert.alertType} is not supported`);

  return null;
};
